var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46281 10.2656C6.57672 10.1546 6.72202 10.1 6.86732 10.1C7.01262 10.1 7.15792 10.1546 7.27125 10.2656L9.73029 12.677V3.76783C9.73029 3.46387 9.98486 3.21628 10.2987 3.21628C10.612 3.21628 10.8671 3.46387 10.8671 3.76783V12.677L13.3256 10.2656C13.5528 10.0442 13.9079 10.0442 14.134 10.2656C14.2421 10.3726 14.302 10.5086 14.3026 10.6527C14.3026 10.7957 14.2427 10.9334 14.134 11.0409L10.7073 14.4247C10.4917 14.6374 10.1156 14.6385 9.9 14.4247L6.46164 11.0386C6.35412 10.9334 6.29484 10.7957 6.29484 10.6527C6.29484 10.5097 6.3547 10.3714 6.46281 10.2656ZM12.8226 5.0578C12.9493 4.78289 13.2817 4.66026 13.563 4.78638C16.0889 5.90983 17.5965 8.2817 17.5965 11.1313C17.5965 15.0765 14.3226 18.2864 10.2984 18.2864C6.27422 18.2864 2.99976 15.0765 2.99976 11.1313C2.99976 8.28809 4.51726 5.91623 7.05825 4.78638C7.13323 4.75267 7.21169 4.73756 7.28899 4.73756C7.5017 4.73756 7.7057 4.85671 7.7987 5.0578C7.85914 5.18857 7.86437 5.33445 7.81381 5.46929C7.76208 5.60703 7.65805 5.71688 7.52088 5.7779C5.35767 6.7392 4.11682 8.69086 4.11682 11.1313C4.11682 14.4755 6.89029 17.1967 10.2984 17.1967C13.7071 17.1967 16.4806 14.4755 16.4806 11.1313C16.4806 8.68388 15.2479 6.73281 13.0998 5.7779C12.9632 5.71746 12.8586 5.60761 12.8069 5.46987C12.7563 5.33503 12.7621 5.18857 12.8226 5.0578Z",
    fill: "#F3F0E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDownload);
export default __webpack_public_path__ + "static/media/symbol-download.105975f55057f1f0646cb5e3d81aba28.svg";
export { ForwardRef as ReactComponent };